import { isString } from 'angular';
export var SystemDictionaryDirective = [
    'contentDictionary',
    function (contentDictionary) {
        return {
            link: function ($scope, $element, $attributes) {
                var key = $attributes.systemDictionary;
                if (!isString(key) || key === '') {
                    return;
                }
                contentDictionary.get(key).then(function (translation) {
                    $element.html(translation);
                });
            },
            restrict: 'A',
        };
    },
];
